import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["kind", "period", "startGroup", "endGroup", "start", "end", "customers", "generate", "stale"]
  static values = { thisMonth: Array, lastMonth: Array }

  connect() {
    this.refresh()
    this.customerChange = () => this.invalidate()
    $(this.customersTarget).on("change.statementBuilder", this.customerChange)
  }

  disconnect() { $(this.customersTarget).off("change.statementBuilder", this.customerChange) }

  invalidate() {
    this.generateTargets.forEach(button => { button.disabled = true })
    this.staleTargets.forEach(message => message.classList.remove("d-none"))
  }

  refresh() {
    const activity = this.kindTarget.value === "activity"
    const custom = this.periodTarget.value === "custom"
    this.startGroupTarget.hidden = !custom || !activity
    this.endGroupTarget.hidden = !custom
    this.startTarget.required = custom && activity
  }

  changePeriod() {
    const dates = { this_month: this.thisMonthValue, last_month: this.lastMonthValue }[this.periodTarget.value]
    if (dates) [this.startTarget.value, this.endTarget.value] = dates
    this.refresh()
    if (!dates) (this.startGroupTarget.hidden ? this.endTarget : this.startTarget).focus()
  }

  customPeriod() {
    this.periodTarget.value = "custom"
    this.refresh()
  }
}
